import AxiosInstance from 'src/shared/services/axios/interceptor';
import { PagedResult } from 'src/shared/models/pagedResult';
import { setPagingParams } from 'src/shared/functions/createPagingParams';
import { DonorResponse, FormDonorPostItem, FormDonorPutItem } from 'src/modules/gift/models/donor';
import { MemberEmail } from 'src/modules/member/models/memberEmail';

const controller = 'Donor';

export const getDonors = (
  pageIndex,
  pageSize,
  sortCol,
  sortDir,
  searchFilter?: string,
  status?: string,
  hasAutogiroMandate?: boolean,
  mandateStatus?: number,
) => {
  let extraQuery = searchFilter ? `&filter=${searchFilter}` : '';
  if (status && status !== 'all') extraQuery += `&status=${status}`;
  if (hasAutogiroMandate) extraQuery += '&hasAutogiroMandate=true';
  if (mandateStatus !== undefined) extraQuery += `&mandateStatus=${mandateStatus}`;
  const endpoint = `${controller}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<DonorResponse>>(endpoint);
};

// En rad per aktiv prenumeration till autogirosidans flik Kopplade månadsgivare. Egen endpoint
// eftersom paginering och total måste räknas på raderna och inte på givarna.
export type DonorAutogiroSubscription = {
  /* eslint-disable camelcase */
  donor_id: number;
  name?: string;
  personalIdentityNumber?: string;
  createdAt?: string;
  subscription_id?: number | null;
  amount?: number | null;
  monthlyFrequency?: number | null;
  lastInvoiceCreated?: string | null;
  mandateStatus: number;
  /* eslint-enable camelcase */
};

export const getDonorAutogiroSubscriptions = (pageIndex, pageSize, sortCol, sortDir, searchFilter?: string, onlyBlocked?: boolean) => {
  let extraQuery = searchFilter ? `&filter=${searchFilter}` : '';
  if (onlyBlocked) extraQuery += '&onlyBlocked=true';

  const endpoint = `${controller}/AutogiroSubscriptions?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<DonorAutogiroSubscription>>(endpoint);
};

export const getDonorById = (id: number | string) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<DonorResponse>(endpoint);
};

export const createForDonor = (donor: FormDonorPostItem) => {
  const endpoint = `${controller}`;
  return AxiosInstance.post<number>(endpoint, donor);
};
export const updateForDonor = (donor: FormDonorPutItem) => {
  const endpoint = `${controller}`;
  return AxiosInstance.put<FormDonorPutItem>(endpoint, donor);
};

export const deleteForDonor = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete<DonorResponse>(endpoint);
};

export const unlinkAutogiroMandateFromDonor = (donorId: number) => {
  const endpoint = `${controller}/${donorId}/ClearMandate`;
  return AxiosInstance.put<number>(endpoint, donorId);
};

export interface DonorStats {
  totalDonors: number;
  activeDonors: number;
  totalMonthlyAmount: number;
  averageMonthlyAmount: number;
  newThisYear: number;
}

export const getDonorStats = () => {
  const endpoint = `${controller}/Stats`;
  return AxiosInstance.get<DonorStats>(endpoint);
};

export const getDonorEmailLog = (donorId: number, pageSize = 5) => {
  const endpoint = `${controller}/${donorId}/Email?${setPagingParams({ pageIndex: 0, pageSize, sortCol: 'mail_id', sortDir: 'desc' })}&sent=true`;
  return AxiosInstance.get<PagedResult<MemberEmail>>(endpoint);
};
